const getters = {
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  userInfo: state => state.user.userInfo,
  staffInfo: state => state.user.staffInfo,
  gradeList: state => state.student.gradeList,
  checkStudentList: state => state.student.checkStudentList,
  loginStatus: state => state.user.loginStatus,
  productType: state => state.course.productType,
  productList: state => state.course.productList,
  banners: state => state.course.banners,
  drawbackItem: state => state.order.drawbackItem
};
export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js